import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import EventSimulator from './EventSimulator';
import NewOrder from './NewOrder';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  divider: {
    width: '100%',
    margin: theme.spacing(2, 0),
  },
}));

export default function Debugger(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <EventSimulator />
      <Divider variant="middle" className={classes.divider} />
      <NewOrder />
    </div>
  );
}